import PropTypes from 'prop-types';

const displayName = 'ModalInput';

const propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  btnLabel: PropTypes.string,
  onClickSubmit: PropTypes.func.isRequired,
};

const defaultProps = {
  title: 'title',
  placeholder: 'placeholder',
  btnLabel: 'btn Label',
  visible: false,
};

export default { displayName, propTypes, defaultProps };
